import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from '../Modal';
import * as modal from '../../reducers/modalReducer';
import EditAddressForm from '../EditAddressForm';
import { getAddressObject } from '../AddressAutocomplete/utils';
import {getPickupAddresses} from '../../selectors/address';

class EditAddressModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      handleSubmitClick: false,
      error: null
    }
  }
  onCloseRequest = () => {
    if (!this.state.handleSubmitClick) {
      this.props.hideModal();
    }
  }
  handleSubmit = (values) => {
      this.setState({
        handleSubmitClick: true
      }, () => {
        const testString = `${values.street} ${values.city} ${values.zip}`;
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ 'address': testString }, (results, status) => {
          if (status !== 'OK') {
            // invalid address
            this.setInvalid('Address is invalid');
            return;
          }
          const location = this.props.location && this.props.location[0] && this.props.location[0].address;
          const allowedZipCodes = JSON.parse(this.props.allowedZipCodes);
          const forbiddenZipCodes = JSON.parse(this.props.forbiddenZipCodes);
          const radius = this.props.radius ? this.props.radius : 20000;
          const centerLat = location && location.latitude ? location.latitude : 37.6853373;
          const centerLng = location && location.longitude ? location.longitude : -122.09284860000002;
          const placeLng = results && results[0] ? results[0].geometry.location.lng() : null;
          const placeLat = results && results[0] ? results[0].geometry.location.lat() : null;
          const distance = window.google.maps.geometry.spherical.computeDistanceBetween(
            new window.google.maps.LatLng(centerLat, centerLng), new window.google.maps.LatLng(placeLat, placeLng)
          );
          getAddressObject(results).then(res => {
          // TODO check if google respose should go as values in db
          values.zip = res.zip;
          values.street = res.street;
          values.city = res.city;

          if (allowedZipCodes.indexOf(values.zip) > -1 ) {
            this.props.onChange(values);
          } else if (distance < radius && forbiddenZipCodes.indexOf(values.zip) === -1) {
            this.props.onChange(values);
          } else {
            this.setInvalid('Your address is not available for delivery');
            return;
          }
          this.props.hideModal();
          });
        });
      })
  }
  setInvalid = (text) => {
    this.setState({
      error: text,
      handleSubmitClick: false
    });
  }
  render() {
    const { address, isDefault } = this.props;
    const initialValues = {
       street: address.street,
       apt: address.apt,
       city: address.city,
       zip: address.zip,
       comment: address.hasOwnProperty('comment') ? address.comment : '',
       isdefault: isDefault ? true : false
    }
    return (
      <Modal
        overlayTop={0}
        closeOnOutsideClick={false}
        isOpened={true}
        onClose={this.onCloseRequest}>
          <EditAddressForm
            initialValues={initialValues}
            isDefault={this.props.isDefault}
            onRemoveAddress={this.props.onRemoveAddress}
            onCloseRequest={this.onCloseRequest}
            onSubmit={this.handleSubmit}
            addressError={this.state.error}
          />
       </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allowedZipCodes: state.config.ALLOWED_ZIP_CODES,
    forbiddenZipCodes: state.config.FORBIDDEN_ZIP_CODES,
    radius: state.config.ECOMMERCE_ADDRESS_RADIUS,
    location: getPickupAddresses(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      hideModal: () => dispatch(modal.hideModal()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditAddressModal);

// const ButtonsWrapperDiv = styled.div `
//   display: flex;
//   justify-content: space-between;
//   width: 255px;
// `;


              // {!this.state.isInputAddressActive &&
              //     <ButtonsWrapperDiv>
              //       <RaisedButton
              //         disabled={!this.isSubmitted()}
              //         onClick={this.handleSubmitClick}
              //         backgroundColor={`#` + this.props.secondaryColor}
              //         labelColor="#FFF"
              //         label="Cancel"
              //         style={styles.submitBtn}
              //       />
              //       <RaisedButton
              //         disabled={!this.isSubmitted()}
              //         onClick={this.handleSubmitClick}
              //         backgroundColor={`#` + this.props.secondaryColor}
              //         labelColor="#FFF"
              //         label="Save"
              //         style={styles.submitBtn}
              //       />
              //     </ButtonsWrapperDiv>
              // }



// WEBPACK FOOTER //
// ./src/components/EditAddressModal/EditAddressModal.jsx